module.exports = __webpack_public_path__ + "img/ordertit_Img.cf6fee16.png";